
/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
*/

/**
 * This function handles the blob types and returns the blob and headers
 * @param {Object} response - response from the API
 * @returns {Object} - returns the blob and headers
 */
export default async function handleBlobTypes(response) {
  const reader = new FileReader();

  const mimeType = response.headers['content-type'];

  // Check if the response is PDF, ZIP, or other types
  if (mimeType === 'application/pdf') {
    const base64EncodedResponse = await new Promise((resolve, reject) => {
      reader.readAsDataURL(response.responseContents);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

    return {
      blob: base64EncodedResponse,
      headers: response.headers
    };
  } else if (mimeType === 'application/zip' || mimeType === 'application/octet-stream') {
    // Handle ZIP or binary data
    const arrayBuffer = await response.responseContents.arrayBuffer();
    return {
      blob: new Blob([arrayBuffer], { type: mimeType }),
      headers: response.headers
    };
  } else {
    // Handle other types as text
    const textToConvert = new Promise((resolve, _reject) => {
      reader.onload = (result) => {
        resolve(result.target.result);
      };
    });

    reader.readAsText(response.responseContents);

    return {
      blob: await textToConvert,
      headers: response.headers
    };
  }
}
